/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchScheduleEndBounded,
  KillswitchScheduleEndBounded$inboundSchema,
  KillswitchScheduleEndBounded$outboundSchema,
} from "./killswitchscheduleendbounded.js";
import {
  KillswitchScheduleEndUntilLifted,
  KillswitchScheduleEndUntilLifted$inboundSchema,
  KillswitchScheduleEndUntilLifted$outboundSchema,
} from "./killswitchscheduleenduntillifted.js";
import {
  KillswitchScheduleStartNow,
  KillswitchScheduleStartNow$inboundSchema,
  KillswitchScheduleStartNow$outboundSchema,
} from "./killswitchschedulestartnow.js";
import {
  KillswitchScheduleStartScheduled,
  KillswitchScheduleStartScheduled$inboundSchema,
  KillswitchScheduleStartScheduled$outboundSchema,
} from "./killswitchschedulestartscheduled.js";

export type KillswitchScheduledBoundedSchedule = {
  start: KillswitchScheduleStartScheduled;
  startsAt: Date;
  end: KillswitchScheduleEndBounded;
  endsAt: Date;
};

export type KillswitchScheduledUntilLiftedSchedule = {
  start: KillswitchScheduleStartScheduled;
  startsAt: Date;
  end: KillswitchScheduleEndUntilLifted;
};

export type KillswitchNowBoundedSchedule = {
  start: KillswitchScheduleStartNow;
  end: KillswitchScheduleEndBounded;
  endsAt: Date;
};

export type KillswitchNowUntilLiftedSchedule = {
  start: KillswitchScheduleStartNow;
  end: KillswitchScheduleEndUntilLifted;
};

export type KillswitchSchedule =
  | KillswitchScheduledBoundedSchedule
  | KillswitchNowBoundedSchedule
  | KillswitchScheduledUntilLiftedSchedule
  | KillswitchNowUntilLiftedSchedule;

/** @internal */
export const KillswitchScheduledBoundedSchedule$inboundSchema: z.ZodMiniType<
  KillswitchScheduledBoundedSchedule,
  unknown
> = z.pipe(
  z.object({
    start: KillswitchScheduleStartScheduled$inboundSchema,
    starts_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    end: KillswitchScheduleEndBounded$inboundSchema,
    ends_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "starts_at": "startsAt",
      "ends_at": "endsAt",
    });
  }),
);
/** @internal */
export type KillswitchScheduledBoundedSchedule$Outbound = {
  start: string;
  starts_at: string;
  end: string;
  ends_at: string;
};

/** @internal */
export const KillswitchScheduledBoundedSchedule$outboundSchema: z.ZodMiniType<
  KillswitchScheduledBoundedSchedule$Outbound,
  KillswitchScheduledBoundedSchedule
> = z.pipe(
  z.object({
    start: KillswitchScheduleStartScheduled$outboundSchema,
    startsAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    end: KillswitchScheduleEndBounded$outboundSchema,
    endsAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      startsAt: "starts_at",
      endsAt: "ends_at",
    });
  }),
);

export function killswitchScheduledBoundedScheduleToJSON(
  killswitchScheduledBoundedSchedule: KillswitchScheduledBoundedSchedule,
): string {
  return JSON.stringify(
    KillswitchScheduledBoundedSchedule$outboundSchema.parse(
      killswitchScheduledBoundedSchedule,
    ),
  );
}
export function killswitchScheduledBoundedScheduleFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchScheduledBoundedSchedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      KillswitchScheduledBoundedSchedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchScheduledBoundedSchedule' from JSON`,
  );
}

/** @internal */
export const KillswitchScheduledUntilLiftedSchedule$inboundSchema:
  z.ZodMiniType<KillswitchScheduledUntilLiftedSchedule, unknown> = z.pipe(
    z.object({
      start: KillswitchScheduleStartScheduled$inboundSchema,
      starts_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      end: KillswitchScheduleEndUntilLifted$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "starts_at": "startsAt",
      });
    }),
  );
/** @internal */
export type KillswitchScheduledUntilLiftedSchedule$Outbound = {
  start: string;
  starts_at: string;
  end: string;
};

/** @internal */
export const KillswitchScheduledUntilLiftedSchedule$outboundSchema:
  z.ZodMiniType<
    KillswitchScheduledUntilLiftedSchedule$Outbound,
    KillswitchScheduledUntilLiftedSchedule
  > = z.pipe(
    z.object({
      start: KillswitchScheduleStartScheduled$outboundSchema,
      startsAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
      end: KillswitchScheduleEndUntilLifted$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        startsAt: "starts_at",
      });
    }),
  );

export function killswitchScheduledUntilLiftedScheduleToJSON(
  killswitchScheduledUntilLiftedSchedule:
    KillswitchScheduledUntilLiftedSchedule,
): string {
  return JSON.stringify(
    KillswitchScheduledUntilLiftedSchedule$outboundSchema.parse(
      killswitchScheduledUntilLiftedSchedule,
    ),
  );
}
export function killswitchScheduledUntilLiftedScheduleFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchScheduledUntilLiftedSchedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      KillswitchScheduledUntilLiftedSchedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchScheduledUntilLiftedSchedule' from JSON`,
  );
}

/** @internal */
export const KillswitchNowBoundedSchedule$inboundSchema: z.ZodMiniType<
  KillswitchNowBoundedSchedule,
  unknown
> = z.pipe(
  z.object({
    start: KillswitchScheduleStartNow$inboundSchema,
    end: KillswitchScheduleEndBounded$inboundSchema,
    ends_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "ends_at": "endsAt",
    });
  }),
);
/** @internal */
export type KillswitchNowBoundedSchedule$Outbound = {
  start: string;
  end: string;
  ends_at: string;
};

/** @internal */
export const KillswitchNowBoundedSchedule$outboundSchema: z.ZodMiniType<
  KillswitchNowBoundedSchedule$Outbound,
  KillswitchNowBoundedSchedule
> = z.pipe(
  z.object({
    start: KillswitchScheduleStartNow$outboundSchema,
    end: KillswitchScheduleEndBounded$outboundSchema,
    endsAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      endsAt: "ends_at",
    });
  }),
);

export function killswitchNowBoundedScheduleToJSON(
  killswitchNowBoundedSchedule: KillswitchNowBoundedSchedule,
): string {
  return JSON.stringify(
    KillswitchNowBoundedSchedule$outboundSchema.parse(
      killswitchNowBoundedSchedule,
    ),
  );
}
export function killswitchNowBoundedScheduleFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchNowBoundedSchedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchNowBoundedSchedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchNowBoundedSchedule' from JSON`,
  );
}

/** @internal */
export const KillswitchNowUntilLiftedSchedule$inboundSchema: z.ZodMiniType<
  KillswitchNowUntilLiftedSchedule,
  unknown
> = z.object({
  start: KillswitchScheduleStartNow$inboundSchema,
  end: KillswitchScheduleEndUntilLifted$inboundSchema,
});
/** @internal */
export type KillswitchNowUntilLiftedSchedule$Outbound = {
  start: string;
  end: string;
};

/** @internal */
export const KillswitchNowUntilLiftedSchedule$outboundSchema: z.ZodMiniType<
  KillswitchNowUntilLiftedSchedule$Outbound,
  KillswitchNowUntilLiftedSchedule
> = z.object({
  start: KillswitchScheduleStartNow$outboundSchema,
  end: KillswitchScheduleEndUntilLifted$outboundSchema,
});

export function killswitchNowUntilLiftedScheduleToJSON(
  killswitchNowUntilLiftedSchedule: KillswitchNowUntilLiftedSchedule,
): string {
  return JSON.stringify(
    KillswitchNowUntilLiftedSchedule$outboundSchema.parse(
      killswitchNowUntilLiftedSchedule,
    ),
  );
}
export function killswitchNowUntilLiftedScheduleFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchNowUntilLiftedSchedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchNowUntilLiftedSchedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchNowUntilLiftedSchedule' from JSON`,
  );
}

/** @internal */
export const KillswitchSchedule$inboundSchema: z.ZodMiniType<
  KillswitchSchedule,
  unknown
> = z.union([
  z.lazy(() => KillswitchScheduledBoundedSchedule$inboundSchema),
  z.lazy(() => KillswitchNowBoundedSchedule$inboundSchema),
  z.lazy(() => KillswitchScheduledUntilLiftedSchedule$inboundSchema),
  z.lazy(() => KillswitchNowUntilLiftedSchedule$inboundSchema),
]);
/** @internal */
export type KillswitchSchedule$Outbound =
  | KillswitchScheduledBoundedSchedule$Outbound
  | KillswitchNowBoundedSchedule$Outbound
  | KillswitchScheduledUntilLiftedSchedule$Outbound
  | KillswitchNowUntilLiftedSchedule$Outbound;

/** @internal */
export const KillswitchSchedule$outboundSchema: z.ZodMiniType<
  KillswitchSchedule$Outbound,
  KillswitchSchedule
> = z.union([
  z.lazy(() => KillswitchScheduledBoundedSchedule$outboundSchema),
  z.lazy(() => KillswitchNowBoundedSchedule$outboundSchema),
  z.lazy(() => KillswitchScheduledUntilLiftedSchedule$outboundSchema),
  z.lazy(() => KillswitchNowUntilLiftedSchedule$outboundSchema),
]);

export function killswitchScheduleToJSON(
  killswitchSchedule: KillswitchSchedule,
): string {
  return JSON.stringify(
    KillswitchSchedule$outboundSchema.parse(killswitchSchedule),
  );
}
export function killswitchScheduleFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchSchedule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchSchedule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchSchedule' from JSON`,
  );
}
